<template>
	<v-row class="mt-0">
		<v-col class="py-0" :cols="isVertical ? 12:6">
			<div :class="disabled ? 'lable-text-disable':'lable-text'">{{ startText }}</div>
			<v-menu
				v-model="menu_start"
				:close-on-content-click="false"
				offset-y
				min-width="auto"
			>
				<template v-slot:activator="{ on, attrs }">
					<v-text-field
						v-bind="attrs"
						v-on="on"
						:value="isSuggestion ? '' :formatDate(date_start)"
						:color="color"
						:background-color="background"
						transition="scale-transition"
						outlined
						dense
						:clearable="clearStartDate"
						persistent-hint
						:placeholder="isSuggestion ? formatDate(date_start) : ''"
						:disabled="disabled"
						:hint="suggestionText"
						:error="startError || date_start_messages.length !== 0"
						:messages="date_start_messages"
						:readonly="isWebsite && $vuetify.breakpoint.smAndDown"
						@click:clear="onDateStartClear()"
						@change="onDateStartChange($event)"
						@keydown="onKeydownStart($event)"
						@input="onDateStartInput($event)"
					>
						<template v-slot:prepend-inner>
							<v-btn icon :disabled="disabled" style="margin-top: 2px" width="20" height="20" @click="menu_start = true">
								<Calendar color="rgba(25, 42, 62, 0.5)" width="20" height="20"/>     
							</v-btn> 
						</template>
					</v-text-field>
				</template>
				<v-date-picker
					v-model="date_start"
					:color="color"
					no-title
					@input="onDateStartPicker()"
				></v-date-picker>
			</v-menu>
			<div v-if="isOptional" class="optional-text">optional</div>
		</v-col>
		<v-col class="py-0" :cols="isVertical ? 12:6">
			<div :class="disabled ? 'lable-text-disable':'lable-text'">{{ endText }}</div>
			<v-menu
				v-model="menu_end"
				:close-on-content-click="false"
				offset-y
				min-width="auto"
			>
				<template v-slot:activator="{ on, attrs }">
					<v-text-field
						v-bind="attrs"
						v-on="on"
						:value="isSuggestion ? '':formatDate(date_end)"
						:color="color"
						:background-color="background"
						transition="scale-transition"
						outlined
						dense
						:clearable="clearEndDate"
						persistent-hint
						:placeholder="isSuggestion ? formatDate(date_end) : ''"
						:disabled="disabled"
						:hint="suggestionText"
						:error="endError || date_end_messages.length !== 0"
						:messages="date_end_messages"
						:readonly="isWebsite && $vuetify.breakpoint.smAndDown"
						@click:clear="onDateEndClear()"
						@change="onDateEndChange($event)"
						@keydown="onKeydownEnd($event)"
						@input="onDateEndInput($event)"
					>
						<template v-slot:prepend-inner>
							<v-btn icon :disabled="disabled" style="margin-top: 2px" width="20" height="20" @click="menu_end = true">
								<Calendar color="rgba(25, 42, 62, 0.5)" width="20" height="20"/>     
							</v-btn> 
						</template>
					</v-text-field>
				</template>
				<v-date-picker
					v-model="date_end"
					:color="color"
					no-title
					@input="onDateEndPicker()"
				></v-date-picker>
			</v-menu>
			<div v-if="isOptional" class="optional-text">optional</div>
		</v-col>
	</v-row>
</template>
<script>
import Calendar from "@/components/icons/calendar.vue";
import moment from 'moment';
import config from "@/config.js";

/** 31 days for a month, (0?[1-9]|[12]\d|3[01])-(0?[13578]|1[02])-((19|20)\d{2}) */
/** 30 days for a month, (0?[1-9]|[12]\d|30)-(0?[469]|11)-((19|20)\d{2}) */
/** 28 days for a month, (0?[1-9]|1\d|2[0-8])-0?2-((19|20)\d{2}) */
/** 29 days for a month, (0?[1-9]|[12]\d)-0?2-((19|20)([13579][26]|[2468][048]|0[48])) */
/** DATE_FORMAT_REG3, day or day+month or day+month+year */
/**
const DATE_FORMAT_REG0 = /^(((0?[1-9]|[12]\d|3[01]) ((J|j)an(uary)?|(M|m)a(r(ch)?|y)|(J|j)ul(y)?|(A|a)ug(ust)?|(O|o)ct(ober)?|(D|d)ec(ember)?) ((19|20)\d{2}))|((0?[1-9]|[12]\d|30) ((A|a)pr(il)?|(J|j)un(e)?|((S|s)ept|(N|n)ov)(ember)?) ((19|20)\d{2}))|((0?[1-9]|[12]\d|30) ((F|f)eb(ruary)?) ((19|20)\d{2}))|((0?[1-9]|[12]\d|30) ((F|f)eb(ruary)?) ((19|20)([13579][26]|[2468][048]|0[48]))))$/;
const DATE_FORMAT_REG1 = /^((0?[1-9]|[12]\d|3[01])\/(0?[13578]|1[02])\/((19|20)\d{2})|(0?[1-9]|[12]\d|30)\/(0?[469]|11)\/((19|20)\d{2})|(0?[1-9]|1\d|2[0-8])\/0?2\/((19|20)\d{2})|(0?[1-9]|[12]\d)\/0?2\/((19|20)([13579][26]|[2468][048]|0[48])))$/;
const DATE_FORMAT_REG2 = /^((0?[1-9]|[12]\d|3[01])\.(0?[13578]|1[02])\.((19|20)\d{2})|(0?[1-9]|[12]\d|30)\.(0?[469]|11)\.((19|20)\d{2})|(0?[1-9]|1\d|2[0-8])\.0?2\.((19|20)\d{2})|(0?[1-9]|[12]\d)\.0?2\.((19|20)([13579][26]|[2468][048]|0[48])))$/;
const DATE_FORMAT_REG3 = /^((0?[1-9]|[12]\d|3[01])|(0[1-9]|[12]\d|3[01])(0?[13578]|1[02])|(0[1-9]|[12]\d|30)(0?[469]|11)|(0[1-9]|1\d|2[0-8])(0?2)|(0[1-9]|[12]\d|3[01])(0[13578]|1[02])((19|20)?\d{2})|(0[1-9]|[12]\d|30)(0[469]|11)((19|20)?\d{2})|(0[1-9]|1\d|2[0-8])(02)((19|20)?\d{2})|(0[1-9]|[12]\d)(02)((19|20)?([13579][26]|[2468][048]|0[48])))$/;
*/

export default {
	name: 'DateRange',
	props: {
		isVertical: {
			type: Boolean,
			default: true
		},
		isIcon: {
			type: Boolean,
			default: true
		},
		startText: {
			type: String,
			default: 'Start Date'
		},
		endText: {
			type: String,
			default: 'End Date'
		},
		color: {
			type: String,
			default: ''
		},
		dateInvalid: {
			type: String,
			default: 'Invalid date'
		},
		dateOverage: {
			type: String,
			default: 'Start date is after End date'
		},
		suggestionText: {
			type: String,
			default: 'eg, 120322 or 12/3/2022 or 12.3.2022'
		},
		/**  accepts ISO 8601 date strings (YYYY-MM-DD) */
		dateStartInit: {
			type: String,
			default: ''
		},
		/**  accepts ISO 8601 date strings (YYYY-MM-DD) */
		dateEndInit: {
			type: String,
			default: ''
		},
		background: {
			type: String,
			default: '#FFFFFF'
		},
		isWebsite: {
			type: Boolean,
			default: true
		},
		clearStartDate: {
			type: Boolean,
			default: true
		},
		clearEndDate: {
			type: Boolean,
			default: true
		},
		disabled: {
			type: Boolean,
			default: false
		},
		isSuggestion: {
			type: Boolean,
			default: false
		},
		isOptional: {
			type: Boolean,
			default: false
		},
		days: {
			type: Number,
			default: 0
		},
		workdays: {
			type: Array,
			default: () => ["monday", "tuesday", "wednesday", "thursday", "friday"]
		},
		startError: {
			type: Boolean,
			default: false
		},
		endError: {
			type: Boolean,
			default: false
		}
	},
	data() {
		return {
			menu_start: false,
			menu_end: false,
			date_start: this.dateStartInit.length !== 0 ? this.dateStartInit : null,
			date_end: this.dateEndInit.length !== 0 ? this.dateEndInit : null,
			date_start_messages: '',
			date_end_messages: '',
			date_format: config.date_format
		}
	},
	components: {
		Calendar
	},
	watch: {
		dateStartInit() {
			this.date_start = this.dateStartInit.length !== 0 ? this.dateStartInit : null;
		},
		dateEndInit() {
			this.date_end = this.dateEndInit.length !== 0 ? this.dateEndInit : null;
		},
		days() {
			this.onDateStartPicker();
		}
	},
	methods: {
		formatDate(value) {
			if(!value) return null;
			return moment(value).format('DD MMM YYYY');
		},
		onDateStartInput(date) {
			/** this function helps the date picker to synchronize with the date, the main logic in onDateStartChange() */
			if (!date) return;

			const isValid = moment(date, this.date_format).isValid();

			if (isValid && this.menu_start) {
				this.date_start = moment(date, this.date_format).format('YYYY-MM-DD');
			}
		},
		onDateStartChange(date) {
			this.date_start_messages = '';
			this.date_end_messages = '';
			if (date) {
				const isValid = moment(date, this.date_format).isValid();

				if (isValid) {
					if (date === '31' && !moment(date, 'DD').isValid()) {
						const pre_month = moment().month() - 1;
						const pre_month_str = moment().month(pre_month).format('MM');
						const date_tmp = `${date}${pre_month_str}`;
						this.date_start = moment(date_tmp, 'DDMM').format('YYYY-MM-DD');
					} else {
						this.date_start = moment(date, this.date_format).format('YYYY-MM-DD');
					}
					
					if (this.date_start && this.date_end && this.date_start > this.date_end) {
						this.date_end_messages = this.dateOverage;
					}
					this.$emit('dateStart', this.date_start);
				} else {
					this.date_start_messages = this.dateInvalid;
					this.$emit('dateStart', null);
				}
			} else {
				this.$emit('dateStart', null);
			}
		},
		onDateStartPicker() {
			if (this.date_start !== null) {
				if (this.days > 1) {
					let date = moment(this.date_start).add(0, 'days').format('YYYY-MM-DD');
					for (let index = 0; index < this.days -1; index++) {
						const date_tmp = moment(date).add(1, 'days').format('YYYY-MM-DD');
						date = this._isWorkDay(date_tmp, this.workdays);
					}

					this.date_end = date;
				}

				if (this.days <= 1) {
					this.date_end = this.date_start;
				}
				
				this.$emit('dateEnd', this.date_end);
			}
			this.menu_start = false;
			this.date_start_messages = '';
			this.date_end_messages = '';
			if (this.date_start && this.date_end && this.date_start > this.date_end) {
				this.date_end_messages = this.dateOverage;
			}
			this.$emit('dateStart', this.date_start);
		},
		onDateStartClear() {
			this.date_start = null;
			this.date_start_messages = '';
			this.$emit('dateStart', null);
		},
		onKeydownStart(e) {
			if (e.keyCode === 13) {
				this.menu_start = false;
			}
		},
		onDateEndInput(date) {
			/** this function helps the date picker to synchronize with the date, the main logic in onDateEndInput() */
			//if (!date) return;
			if (!date) {
				this.$emit('dateEnd', null);
			}

			const isValid = moment(date, this.date_format).isValid();

			if (isValid && this.menu_end) {
				this.date_end = moment(date, this.date_format).format('YYYY-MM-DD');
			}
		},
		onDateEndChange(date) {
			this.date_end_messages = '';
			if (date) {
				const isValid = moment(date, this.date_format).isValid();

				if (isValid) {
					if (date === '31' && !moment(date, 'DD').isValid()) {
						const pre_month = moment().month() - 1;
						const pre_month_str = moment().month(pre_month).format('MM');
						const date_tmp = `${date}${pre_month_str}`;
						this.date_end = moment(date_tmp, 'DDMM').format('YYYY-MM-DD');
					} else {
						this.date_end = moment(date, this.date_format).format('YYYY-MM-DD');
					}
					if (this.date_start && this.date_end && this.date_start > this.date_end) {
						this.date_end_messages = this.dateOverage;
					}
					this.$emit('dateEnd', this.date_end);
				} else {
					this.date_end_messages = this.dateInvalid;
					this.$emit('dateEnd', null);
				}
			} else {
				this.$emit('dateEnd', null);
			}
		},
		onDateEndPicker() {
			this.menu_end = false;
			this.date_end_messages = '';
			if (this.date_start && this.date_end && this.date_start > this.date_end) {
				this.date_end_messages = this.dateOverage;
			}

			this.$emit('dateEnd', this.date_end);
		},
		onDateEndClear() {
			this.date_end = null;
			this.date_end_messages = '';
			this.$emit('dateEnd', this.date_end);
		},
		onKeydownEnd(e) {
			if (e.keyCode === 13) {
				this.menu_end = false;
			}
		},
		_isWorkDay(current_day, workdays) {
			let end_date = moment(current_day).format('YYYY-MM-DD');

			if (!workdays.includes((moment(end_date).format('dddd')).toLocaleLowerCase()) && workdays.length !== 0) {
				const end_date_tmp = moment(current_day).add(1, 'days').format('YYYY-MM-DD');
				end_date = this._isWorkDay(end_date_tmp, workdays);
			}
			
			return end_date;
		},
	}
}
</script>
<style lang="scss" scoped>
.lable-text {
  font-family: 'Roboto';
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  letter-spacing: 0.25px;
  color: #37495F;
  opacity: 0.87;
}
.lable-text-disable {
  font-family: 'Roboto';
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  letter-spacing: 0.25px;
  color: #B9C2CB;
  opacity: 0.87;
}
.optional-text {
	position: relative;
  top: -26px;
	right: -12px;

	font-family: Roboto;
	font-style: normal;
	font-weight: normal;
	font-size: 12px;
	line-height: 20px;

	text-align: right;
	letter-spacing: 0.4px;
	color: #37495F;
}

.icon-hover {
	&:hover {
		cursor: pointer;
	}
}
</style>